<!--
    One binding per custom property, not one bag: each reads a single node of the
    signal form, so a padding edit rewrites four declarations rather than forty.
-->
<div
    class="block-wrap"
    [class.has-own-height]="hasOwnHeight()"
    [class.is-hidden-on-view]="isHiddenOnView()"
    [style.--block-max-width]="maxWidth()"
    [style.--block-height]="blockHeight()"
    [style.--block-height-tablet]="blockHeightTablet()"
    [style.--block-height-mobile]="blockHeightMobile()"
    [style.--block-padding-top]="paddingTop()"
    [style.--block-padding-right]="paddingRight()"
    [style.--block-padding-bottom]="paddingBottom()"
    [style.--block-padding-left]="paddingLeft()"
    [style.--block-border-top]="borderTop()"
    [style.--block-border-right]="borderRight()"
    [style.--block-border-bottom]="borderBottom()"
    [style.--block-border-left]="borderLeft()"
    [style.--block-border-top-width]="borderTopWidth()"
    [style.--block-border-right-width]="borderRightWidth()"
    [style.--block-border-bottom-width]="borderBottomWidth()"
    [style.--block-border-left-width]="borderLeftWidth()"
    [style.--block-bg]="bg()"
    [style.--block-bg-position]="bgPosition()"
    [style.--block-bg-repeat]="bgRepeat()"
    [style.--block-bg-size]="bgSize()"
    [style.--block-bg-filter]="bgFilter()"
    [style.--block-bg-margin]="bgMargin()"
    [style.--block-padding-top-tablet]="paddingTopTablet()"
    [style.--block-padding-right-tablet]="paddingRightTablet()"
    [style.--block-padding-bottom-tablet]="paddingBottomTablet()"
    [style.--block-padding-left-tablet]="paddingLeftTablet()"
    [style.--block-border-top-tablet]="borderTopTablet()"
    [style.--block-border-right-tablet]="borderRightTablet()"
    [style.--block-border-bottom-tablet]="borderBottomTablet()"
    [style.--block-border-left-tablet]="borderLeftTablet()"
    [style.--block-border-top-width-tablet]="borderTopWidthTablet()"
    [style.--block-border-right-width-tablet]="borderRightWidthTablet()"
    [style.--block-border-bottom-width-tablet]="borderBottomWidthTablet()"
    [style.--block-border-left-width-tablet]="borderLeftWidthTablet()"
    [style.--block-bg-tablet]="bgTablet()"
    [style.--block-bg-position-tablet]="bgPositionTablet()"
    [style.--block-bg-repeat-tablet]="bgRepeatTablet()"
    [style.--block-bg-size-tablet]="bgSizeTablet()"
    [style.--block-bg-filter-tablet]="bgFilterTablet()"
    [style.--block-bg-margin-tablet]="bgMarginTablet()"
    [style.--block-padding-top-mobile]="paddingTopMobile()"
    [style.--block-padding-right-mobile]="paddingRightMobile()"
    [style.--block-padding-bottom-mobile]="paddingBottomMobile()"
    [style.--block-padding-left-mobile]="paddingLeftMobile()"
    [style.--block-border-top-mobile]="borderTopMobile()"
    [style.--block-border-right-mobile]="borderRightMobile()"
    [style.--block-border-bottom-mobile]="borderBottomMobile()"
    [style.--block-border-left-mobile]="borderLeftMobile()"
    [style.--block-border-top-width-mobile]="borderTopWidthMobile()"
    [style.--block-border-right-width-mobile]="borderRightWidthMobile()"
    [style.--block-border-bottom-width-mobile]="borderBottomWidthMobile()"
    [style.--block-border-left-width-mobile]="borderLeftWidthMobile()"
    [style.--block-bg-mobile]="bgMobile()"
    [style.--block-bg-position-mobile]="bgPositionMobile()"
    [style.--block-bg-repeat-mobile]="bgRepeatMobile()"
    [style.--block-bg-size-mobile]="bgSizeMobile()"
    [style.--block-bg-filter-mobile]="bgFilterMobile()"
    [style.--block-bg-margin-mobile]="bgMarginMobile()"
>
    @if (!isHiddenOnView()) {
        <web-block-shape-dividers [entity]="entity()" />

        @if (!isParallax()) {
            <div class="block-bg" [class.has-fixed-bg]="isFixedBg()">
                @if (desktopVideoUrl()) {
                    <video
                        class="desktop-video"
                        style="width: 100%; height: 100%; object-fit: cover"
                        [autoplay]="true"
                        [muted]="true"
                        [loop]="true"
                        [src]="desktopVideoUrl()"
                    ></video>
                }
                @if (mobileVideoUrl()) {
                    <video
                        class="mobile-video"
                        style="width: 100%; height: 100%; object-fit: cover"
                        [autoplay]="true"
                        [muted]="true"
                        [loop]="true"
                        [src]="mobileVideoUrl()"
                    ></video>
                }
            </div>
        } @else {
            <div class="parallax-container">
                <div class="background-parallax">
                    <div class="parallax-wrapper">
                        <div class="parallax">
                            <div class="block-bg background has-parallax"></div>
                        </div>
                    </div>
                </div>
            </div>
        }

        <div class="block-inner" [class.smallTopSpacing]="isBlockSmallTopSpacing()">
            @for (section of sections(); let i = $index; track section.id) {
                <web-default-section
                    [index]="i"
                    [entity]="section"
                    [parentEntityId]="entity().id"
                    [hasSectionActiveColumn]="hasActiveColumn(section)"
                    [isLastSection]="sections().length === 1"
                />
            }
        </div>
    } @else {
        <div class="hidden-block-placeholder">
            {{ hiddenHintText() | translate }}
        </div>
    }
</div>
